export enum RewardsRedemptionProvider {
    TangoV2 = 'TangoV2'
}
